import React      from 'react';          // @see https://www.npmjs.com/package/react
import { motion } from 'framer-motion';  // @see https://www.npmjs.com/package/framer-motion

import { numericField } from 'components/animations/utils';


interface Props {
  elementType:         string;
  children?:           React.ReactNode;
  triggered:           boolean;
  magnifyRatio?:       number;
  duration?:           number;
  [otherProp: string]: any;
}

const AnimationJump: React.FC<Props> = (props: Props) => {

  const {
    elementType,   // 'div', 'span', 'img', etc.
    children,      // Children (for an element which can accept children, such as a <div>).
    triggered,     // Set this to `false` initially. Change to `true` to trigger the animation.
    magnifyRatio,  // Amount to magnify the element (eg: `2.0` will magnify the element to twice its original size).
    duration,      // Duration (in seconds) of the animation.
    ...otherProps
  } = props;

  // @see https://www.framer.com/api/motion/component/
  // @ts-ignore
  const component = motion[elementType];

  let scale: number | number[] = 1;

  if (triggered) {
    scale = [
      1,
      numericField(magnifyRatio, 1.33),
      1,
      numericField(magnifyRatio, 1.18),
      1,
      numericField(magnifyRatio, 1.08),
      1,
      numericField(magnifyRatio, 1.03),
      1
    ];  // Keyframes for the animation.
  }

  const allProps = {
    ...otherProps,
    animate:    { scale },                    // @see https://www.framer.com/api/motion/animation/#target-object
    transition: {                             // @see https://www.framer.com/api/motion/animation/#transitions
      duration: numericField(duration, 1.2)  // @see https://www.framer.com/api/motion/types/#tween.duration
    }
  };

  return React.createElement(component, allProps, children);

};

export default AnimationJump;
